export const GAME_VERSION = "v1.0.8";

export const TRACK_NAMES = [
  "abudhabi",
  "albertpark",
  "americas",
  "bahrain",
  "baku",
  "budapest",
  "catalunya",
  "hockenheim",
  "interlagos",
  "marinabay",
  "mexico",
  "monaco",
  "montreal",
  "monza",
  "paulricard",
  "shanghai",
  "silverstone",
  "sochi",
  "spa",
  "spielberg",
  "suzuka",
];

export const TRACK_DISPLAY_NAMES = {
  abudhabi: "Yas Marina Circuit, United Arab Emirates",
  albertpark: "Albert Park Circuit, Australia",
  americas: "Circuit of the Americas, United States",
  bahrain: "Bahrain International Circuit, Bahrain",
  baku: "Baku City Circuit, Azerbaijan",
  budapest: "Hungaroring, Hungary",
  catalunya: "Circuit de Barcelona-Catalunya, Spain",
  hockenheim: "Hockenheimring, Germany",
  interlagos: "Autódromo José Carlos Pace, Brazil",
  marinabay: "Marina Bay Street Circuit, Singapore",
  mexico: "Autódromo Hermanos Rodríguez, Mexico",
  monaco: "Circuit de Monaco, Monaco",
  montreal: "Circuit Gilles Villeneuve, Canada",
  monza: "Autodromo Nazionale di Monza, Italy",
  paulricard: "Circuit Paul Ricard, France",
  shanghai: "Shanghai International Circuit, China",
  silverstone: "Silverstone Circuit, United Kingdom",
  sochi: "Sochi Autodrom, Russia",
  spa: "Circuit de Spa-Francorchamps, Belgium",
  spielberg: "Red Bull Ring, Austria",
  suzuka: "Suzuka Racing Course, Japan",
};

export const TEAMS = [
  {
    name: "MacLairen Motors",
    primary: "#FF6E0A", // vivid papaya orange (McLaren-like, slightly warmer)
    secondary: "#1A1A1A", // deep graphite
    accent: "#00B5FF", // light cyan streak accent
  },
  {
    name: "Astern Martian",
    primary: "#115C3C", // deep emerald (Aston-ish but darker)
    secondary: "#C0B283", // metallic champagne trim
    accent: "#25E89B", // neon mint accent
  },
  {
    name: "Alphine Peaks",
    primary: "#1A3DE0", // bright alpine blue
    secondary: "#E2E2E2", // silver-gray
    accent: "#FF1E3C", // tricolor red accent
  },
  {
    name: "Alpha Omego Racing",
    primary: "#9A0019", // burgundy wine
    secondary: "#EDEDED", // near-white
    accent: "#1F6FFF", // small blue stripe accent
  },
  {
    name: "Hazz Autosport",
    primary: "#BFBFBF", // light gray base
    secondary: "#212121", // matte black trim
    accent: "#E43131", // red accent stripe
  },
  {
    name: "Red Ox Velocity",
    primary: "#2E2B87", // navy indigo base
    secondary: "#F3D000", // gold-yellow bull pattern (less saturated)
    accent: "#E42C2C", // red logo accent
  },
  {
    name: "Scuderia Albatross",
    primary: "#2E89A0", // turquoise blue (AlphaTauri-ish)
    secondary: "#ECECEC", // off-white
    accent: "#1E1E1E", // charcoal details
  },
  {
    name: "Willpower Racing",
    primary: "#2244FF", // rich royal blue (Williams-like)
    secondary: "#F0F0F0", // white chassis
    accent: "#FF2C9F", // magenta accent line
  },
  {
    name: "Scuderia Fajita",
    primary: "#D82020", // spicy red
    secondary: "#F3E2C0", // tortilla tan secondary
    accent: "#222222", // black trim
  },
  {
    name: "Mercury-AMG Photon",
    primary: "#C0C0C0", // metallic silver
    secondary: "#111111", // carbon black
    accent: "#05FFD5", // bright teal (Merc AMG greenish glow)
  },
];
